<div class="purchased-track-container">
  <div class="purchased-track">
    <!-- Image -->
    <img loading="lazy" src="{{ track?.fullBeatInfo?.images?.middle }}" alt="{{ track.beatName }} cover" />

    <!-- Info -->
    <div class="purchased-track__content">
      <p class="purchased-track__date">Purchase date: {{ track.purchasedDate | slice: 6 : 19 | date: 'medium' }}</p>

      <div class="purchased-track__info">
        <p class="purchased-track__name">
          Beat name:
          <a routerLink="/beat/{{ track.beatId }}">{{ track.beatName }}</a>
        </p>
        <p class="purchased-track__name purchased-track__name--beatmaker">
          <b>Beatmaker name: </b>
          <a routerLink="/bm/{{ track.beatmakerId }}">{{ track.beatmakerName }}</a>
        </p>
        <p class="purchased-track__text"><b>License: </b>"{{ track.license.title }}"</p>
      </div>

      <!-- Price -->
      <p class="purchased-track__text">
        <b>Price: </b>
        @if (track.currency === 'USD') {
          <span class="purchased-track__price">$</span>
        }
        {{ track.price }}
        @if (track.currency === 'RUB') {
          <span>₽</span>
        }
      </p>
    </div>

    <!-- Buttons -->
    <div class="purchased-track__buttons">
      <!-- Download license button -->
      @if (track.engPdfExists) {
        <div class="purchased-track__btn">
          <bmcore-button
            title="Download license"
            icon="{{ mobMode ? '' : 'icon-download' }}"
            styleName="track"
            component="LinkHref"
            linkPath="{{ downloadLicenseURL }}?beatId={{ track.beatId }}&paymentId={{ track.paymentId }}&buyerId={{
              buyerId
            }}"
          >
          </bmcore-button>
        </div>
      }

      <!-- Download files button -->
      <div class="purchased-track__btn">
        <bmcore-button
          title="Download files"
          icon="{{ mobMode ? '' : 'icon-btn-list' }}"
          styleName="{{ isPurchaseTrackExpanded ? 'dropdown-active' : 'track' }}"
          (clickHandler)="downloadFilesHandler(track)"
        >
        </bmcore-button>
      </div>

      <!-- Download files from url -->
      <div class="purchased-track__dropdown-box">
        @if (isPurchaseTrackExpanded) {
          <div class="purchased-track__dropdown">
            @if (!mobMode) {
              <div class="bm--dropdown-triangle bm--dropdown-triangle--download-files"></div>
            }
            @if (mobMode) {
              <div class="purchased-track__mob-title">
                <p>Download files</p>
                <span class="icon-close" (click)="closePopup()"></span>
              </div>
            }
            @for (file of track.files; track file) {
              <!-- Pending-->
              @if (filesReadyValues[file.id]?.isPreparing()) {
                <bmcore-button
                  [isLoader]="true"
                  styleName="download-dropdown"
                  title="{{ file.name }}.{{ file.extension }}"
                >
                </bmcore-button>
                <p class="purchased-track__status purchased-track__status--pending">
                  File preparing to download: {{ filesReadyValues[file.id].percents }} %
                </p>
              }
              <!-- Error-->
              @if (filesReadyValues[file.id]?.hasError()) {
                <bmcore-button
                  icon="btv-icon-btn-return"
                  styleName="download-dropdown"
                  title="{{ file.name }}.{{ file.extension }}"
                  (clickHandler)="tryCheckFileAgain(file, track)"
                >
                </bmcore-button>
                <p class="purchased-track__status purchased-track__status--error">
                  {{ filesReadyValues[file.id].error }}
                </p>
              }
              <!-- Success-->
              @if (filesReadyValues[file.id]?.readyToDownloading()) {
                <bmcore-button
                  title="{{ file.name }}.{{ file.extension }}&nbsp;&nbsp; {{ file.size && file.size + 'MB' }}"
                  icon="btv-icon-download"
                  component="LinkHref"
                  styleName="download-dropdown"
                  linkPath="{{ baseUrl }}/web/v1/download-file?fileId={{ file.id }}&paymentId={{
                    track.paymentId
                  }}&beatId={{ track.beatId }}&hash={{ hash }}&userId={{ userId }}"
                >
                </bmcore-button>
                <p class="purchased-track__status purchased-track__status--success">File ready to download</p>
              }
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>
